import React from 'react'
import styled from 'styled-components'

import { media, mediaMax } from 'styles/media'

const Intro = styled.div<{ reducedMarginBottom?: boolean }>`
  text-align: center;
  max-width: 870px;

  margin-top: 80px;
  margin-bottom: ${({ reducedMarginBottom }) =>
    reducedMarginBottom ? '20px' : '40px'};

  ${mediaMax.md`
    text-align: left;
  `}

  ${media.md`
    margin-top: 180px;
    margin-bottom: 100px;
    margin-bottom: ${({
      reducedMarginBottom,
    }: {
      reducedMarginBottom?: boolean
    }) => (reducedMarginBottom ? '40px' : '100px')};
    `}

  & > * {
    &:last-child {
      margin-bottom: 0;
    }
  }

  h3 {
    font-size: ${({ theme }) => theme['-ds-font-size-md']['font-size'].value};
    font-weight: 200;
    line-height: 1.15;
    text-transform: uppercase;
    color: ${({ theme }) => theme.brand.jungle};
    margin-bottom: 20px;

    ${mediaMax.md`
      font-size: 16px;
    `}
  }

  h2 {
    font-size: ${({ theme }) => theme['-ds-font-size-xxl']['font-size'].value};
    font-weight: ${({ theme }) =>
      theme['-ds-font-size-xxl']['font-weight'].value};
    line-height: 1.1;
    color: ${({ theme }) => theme.brand.forest};
    margin-bottom: 16px;

    ${mediaMax.md`
      font-size: 32px;
    `}
  }

  p {
    font-size: ${({ theme }) => theme['-ds-font-size-lg']['font-size'].value};
    line-height: 1.7;
    font-weight: ${({ theme }) =>
      theme['-ds-font-size-lg']['font-weight'].value};
    color: ${({ theme }) => theme.colors.textGreyDarker};

    ${mediaMax.md`
      font-size: ${({ theme }) => theme['-ds-font-size-xs']['font-size'].value};
    `}
  }
`

type SectionIntroProps = {
  primaryHeading: React.ReactNode
  secondaryHeading?: React.ReactNode
  paragraphText: React.ReactNode
  style?: React.CSSProperties
  reducedMarginBottom?: boolean
}

const SectionIntro: React.FC<SectionIntroProps> = ({
  primaryHeading,
  secondaryHeading,
  paragraphText,
  style,
  reducedMarginBottom,
}) => {
  return (
    <Intro style={style} reducedMarginBottom={reducedMarginBottom}>
      {secondaryHeading && <h3>{secondaryHeading}</h3>}
      <h2>{primaryHeading}</h2>
      <p>{paragraphText}</p>
    </Intro>
  )
}

export default SectionIntro
